import React from 'react';
import { Paper, ListItem, Typography } from '@mui/material';
import { Role } from '../types/roles';

interface RolesListProps {
  roles: Role[];
  selectedRole: Role | null;
  onSelectRole: (role: Role) => void;
}

const RolesList: React.FC<RolesListProps> = ({ roles, selectedRole, onSelectRole }) => {
  return (
    <Paper sx={{ p: 2, height: 400, overflowY: 'auto' }}>
      {roles.map((role) => (
        <ListItem
          key={role.id}
          component="div"
          onClick={() => onSelectRole(role)}
          sx={{
            mb: 1,
            py: 1.5,
            borderRadius: 1,
            bgcolor: (theme) => selectedRole?.id === role.id ? theme.palette.custom.selectedListItem : 'background.paper',
            color: selectedRole?.id === role.id ? 'white' : 'text.primary',
            cursor: 'pointer',
            '&:hover': {
              opacity: selectedRole?.id === role.id ? '0.8' : '1',
            },
          }}
        >
          <Typography variant="body1">{role.name}</Typography>
        </ListItem>
      ))}
    </Paper>
  );
};

export default RolesList;